<template>
  <v-row no-gutters>
    <v-container fluid>
      <v-row no-gutters class="row1" :justify="$vuetify.breakpoint.smAndDown ? 'center': 'start'">
        <v-col :cols="$vuetify.breakpoint.width < 500 ? '12' : $vuetify.breakpoint.width > 500 && $vuetify.breakpoint.width < 1025 ? '8' : '8'">
          <vuetify-google-autocomplete
              solo
              outlined
              color="main"
              autocomplete="on"
              background-color="white"
              class="location"
              id="location"
              ref="location1"
              type="address"
              :enable-geolocation="true"
              placeholder="Collection Address"
              v-on:placechanged="locationChange1"
              v-model="collectionAddress"
              country="za"
              :disabled="loading"
              :error="errorMessage1.length > 0"
              :error-messages="errorMessage1"
          >
            <template #append>
              <div :class="{'bounce': collectionAddress.length === 0}">
                <feather type="map-pin"/>
              </div>
            </template>
          </vuetify-google-autocomplete>
          <v-text-field 
            v-if="Object.keys(location1).length > 0 && !location1.postal_code"
            type="number" 
            solo 
            v-model="customCode1"
            placeholder="Enter Post Code for Collection Address"
            :error="String(customCode1).length > 0 && String(customCode1).length !== 4"
            :error-messages="String(customCode1).length === 4 ? '' : 'Enter a valid post code'" />
          <vuetify-google-autocomplete
              solo
              outlined
              color="main"
              autocomplete="on"
              background-color="white"
              class="location"
              id="location2"
              ref="location2"
              type="address"
              :enable-geolocation="true"
              placeholder="Delivery Address"
              v-on:placechanged="locationChange2"
              v-model="deliveryAddress"
              country="za"
              :disabled="loading"
              :error="errorMessage2.length > 0"
              :error-messages="errorMessage2"
          >
            <template #append>
              <div :class="{'bounce': collectionAddress.length != 0 && deliveryAddress.length === 0}">
                <feather type="map-pin"/>
              </div>
            </template>
          </vuetify-google-autocomplete>
          <v-text-field 
            v-if="Object.keys(location2).length > 0 && !location2.postal_code"
            type="number" 
            solo 
            v-model="customCode2"
            placeholder="Enter Post Code for Delivery Address"
            :error="String(customCode2).length > 0 && String(customCode2).length !== 4"
            :error-messages="String(customCode2).length === 4 ? '' : 'Enter a valid post code'" />
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col>
          <v-btn
          class="links col3-btn"
          height="56"
          width="200"
          color="primary"
          @click="proceed">Get Quote</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col style="font-family: Avenir1;">
          <a href="tel:+27829099712" class="primry--text head1">082 909 9712</a>
          <p>Or call us for fast service </p>
          <!--<br/>
          <h3 style="font-family: Avenir1;" class="info--text">Book any size skip, roro or truck</h3>-->
        </v-col>
      </v-row>
    </v-container>
  </v-row>
</template>

<script>

import { left } from 'core-js/internals/array-reduce'

export default {
  name: "Address",
  props: {
      locationChangeCallback: Function
  },
  data () {
    return {
      canProceed: false,
      location1: {},
      location2: {},
      collectionAddress: '',
      deliveryAddress: '',
      customCode1: Number,
      customCode2: Number,
      postCode: '',
      show: false,
      loading: false,
      showBtnLocation: false,
      helpmessage: "We don't service this area. Please contact 082 909 9712 for assistance.",
      errorMessage1: [],
      errorMessage2: [],
    }
  },
  computed: {
    postal_codes() {
      return this.$store.state.quote.postal_addresses;
    }
  },
  methods: {
    left,
    redirect(){
      window.location.href = 'https://app.dashwaste.co.za/signup';
    },
    focusInput() {
      const locationInput = document.getElementById("location");
      if (locationInput) {
        locationInput.focus();
      } else {
        console.error("Could not find the input with ID 'location'");
      }
    },
    autoLocation(){
      //find user's location automatically
      this.canProceed = false;
      this.loading = true;
      this.capturedAddress = 'Loading ...';
      if(navigator.geolocation){
        navigator.geolocation.getCurrentPosition((location) => {
          let apikey = 'AIzaSyB2xcq18UZ60nYqMNnU4E6Mv7nhrEjxAXo';
          fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${location.coords.latitude},${location.coords.longitude}&key=${apikey}`)
          .then(response => response.json())
          .then(data => {
            // Check if the request was successful and has results
            if (data.status === 'OK' && data.results.length > 0) {
              const address = data.results[0].formatted_address;
              this.capturedAddress = address;
              this.canProceed = true;
              let postalCode = data.results[0].address_components;
              let postCode = postalCode.find((code) => code.types.includes('postal_code'));
              if(postCode){
                this.postCode = postCode.long_name;
              }
              else{
                this.show = true;
                this.loading = false;
                this.showBtnLocation = false;
              }

            } else {
              alert('Unable to retrieve your location. Please allow Dash Waste to use your location');
              this.loading = false;
              this.showBtnLocation = false;
            }
          })
          .catch(error => {
            alert('Error fetching location');
            console.error('Error fetching address:', error);
            this.loading = false;
            this.showBtnLocation = false;
          });

        }, (error) => {
          console.log(error);
          alert('Unable to retrieve your location. Please allow Dash Waste to use your location');
          this.$router.go();
        })
      }
      else{
        alert('Unable to retrieve your location. Please allow Dash Waste to use your location');
        this.$router.go();
      }
    },
    locationChange1(to) {
      this.location1 = to;
      if (!to.postal_code) {
        this.errorMessage1 = ["The selected address doesn't have a postal code"]
      } else {
        this.errorMessage1 = this.isValidPostalCode(Number(to.postal_code)) ? [] : [this.helpmessage];
      }
    },

    locationChange2(to) {
      if (this.collectionAddress !== this.deliveryAddress) {
        this.location2 = to;
        if (!to.postal_code) {
          this.errorMessage2 = ["The selected address doesn't have a postal code"]
        } else {
          this.errorMessage2 = this.isValidPostalCode(Number(to.postal_code)) ? [] : [this.helpmessage];
          this.canProceed = this.isValidPostalCode(Number(to.postal_code));
        }
      }
    },

    isValidPostalCode(post_code) {
      return this.postal_codes.some(code => {
        return post_code >= code.start && post_code <= code.end;
      })
    },
    async proceed() {
      if (!this.location1.postal_code && String(this.customCode1).length === 4) {
        this.canProceed = this.isValidPostalCode(this.customCode1);
      } else if (!this.location2.postal_code && String(this.customCode2).length === 4) {
        this.canProceed = this.isValidPostalCode(this.customCode2);
      }

      if (!this.canProceed) {
        this.$store.dispatch('toastr/addToastr', {
          id: `toast-${Date.now()}`,
          type: 't-warning',
          title: 'Alert',
          message: Object.keys(this.location1).length === 0 || Object.keys(this.location2).length === 0  ? 'Please make sure to enter both addresses.' : this.helpmessage,
          options: {
            timeout: 4000
          }
        });
        return;
      }
      if (this.collectionAddress === '' || !this.collectionAddress || !this.deliveryAddress || this.deliveryAddress === '') {
        this.$store.dispatch('toastr/addToastr', {
          id: `toast-${Date.now()}`,
          type: 't-warning',
          title: 'Alert',
          message: 'Please enter your address!',
          options: {
            timeout: 3000
          }
        });
        this.canProceed = false;
        return;
      }
      if (this.collectionAddress.length < 10 || this.deliveryAddress.length < 10) {
        alert('Please enter correct address');
        this.canProceed = false;
        return;
      }

      // uncomment postal code check for  later

      // if (this.capturedAddress.length > 5 && !this.location.postal_code && this.postCode.length != 4){
      //   this.canProceed = false;
      //   alert('Please enter correct post code for your address');
      //   return;
      // }
      else{
        this.canProceed = true;
        this.locationChangeCallback(this.collectionAddress, this.deliveryAddress);
      }
    }
  },
  mounted(){}
}
</script>

<style>
/** Global style for the bounce effect */
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-15px);
  }
}

.bounce {
  animation: bounce 1.5s infinite;
}
</style>

<style scoped>
.links{
  font-family: Avenir2;
  font-style: normal;
  font-size: 16px;
  line-height: 20px;
}
.head1{
  font-size: 30px;
  text-decoration: none;
}
.location{
  font-size: 23px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.col2-btn{
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

@media screen and (max-width: 480px){
  .row1{
    width: 100%;
    display: inline-block;
    margin-bottom: 1.5cm;
  }
  .location{
    border-radius: 5px;
  }
  .col2{
    margin-top: -0.5cm;
  }
  .col2-btn{
    width: 100%;
    border-radius: 30px;
  }
  .col3-btn{
    width: 100%;
    border-radius: 30px;
  }

}

</style>
